// Elements
import { Container, Disclaimer, Logo } from "./Footer.elements";

export default function Footer() {
  return (
    <Container>
      <Disclaimer>
        <p>Copyright © 2025 American Express Company</p>
      </Disclaimer>
      <Logo />
    </Container>
  );
}
